import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import {
  UpdateSoftwareResponseSchema,
  UpdateSoftwareSchema,
} from './software.schema';

export const softwareContractRoutes = {
  updateSoftware: terraContract
    .meta({
      permissionsAll: [
        PERMISSIONS.MANAGE_APPLICATIONS.name,
        PERMISSIONS.EXECUTE_TESTS.name,
      ],
    })
    .route({
      method: 'PUT',
      path: '/{surfaceId}/software',
      summary: 'Upsert software on a network service',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ surfaceId: z.string() }),
        body: UpdateSoftwareSchema,
      }),
    )
    .output(UpdateSoftwareResponseSchema),
  deleteSoftware: terraContract
    .meta({
      permissions: [PERMISSIONS.MANAGE_APPLICATIONS.name],
    })
    .route({
      method: 'DELETE',
      path: '/{surfaceId}/software/{softwareId}',
      summary: 'Delete software',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: z.object({ surfaceId: z.string(), softwareId: z.string() }),
        body: z.object({}),
      }),
    )
    .output(UpdateSoftwareResponseSchema),
};
